export const ANNOUNCEMENT_STATE = {
  OFF: 0,
  ON: 1,
};

export const ANNOUNCEMENT_STATE_OPTIONS = [
  { value: '', label: '全部' },
  { value: String(ANNOUNCEMENT_STATE.ON), label: '已發布' },
  { value: String(ANNOUNCEMENT_STATE.OFF), label: '已下架' },
];

export const ANNOUNCEMENT_FORM_STATE_OPTIONS = [
  { value: ANNOUNCEMENT_STATE.ON, label: '已發布' },
  { value: ANNOUNCEMENT_STATE.OFF, label: '已下架' },
];

export const ANNOUNCEMENT_PAGE_SIZE = 20;
export const EN_LANG_CODE = 'en_US';

export function buildAnnouncementPageParams(pageNo, filters = {}, pageSize = ANNOUNCEMENT_PAGE_SIZE) {
  const params = { pageNo, pageSize };
  if (filters.state !== '' && filters.state != null) {
    params.state = Number(filters.state);
  }
  if (filters.title?.trim()) {
    params.title = filters.title.trim();
  }
  return params;
}

export function formatAnnouncementState(state) {
  return state === ANNOUNCEMENT_STATE.ON ? '已發布' : '已下架';
}

export function emptyAnnouncementDetail(lang) {
  return {
    lang,
    title: '',
    body: '',
  };
}

export function mergeAnnouncementDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({
      code: item.lang,
      label: item.lang,
    });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyAnnouncementDetail(code), _label: label };
  });
}

export function stripAnnouncementDetails(details) {
  return (details || []).map(({ lang, title, body }) => ({
    lang,
    title: title || '',
    body: body || '',
  }));
}
